<template>
  <div class="list">
    <template v-if="sortedInteractionsChannels?.length">
      <ChannelDropdownButton
        v-for="channelGroup in sortedInteractionsChannels"
        :key="channelGroup.icon"
        :groupedChannel="channelGroup"
      />
    </template>

    <template v-else>
      <a-skeleton-button class="skeleton" :active="active" />
    </template>
  </div>
</template>

<script>
import { inject, computed } from "vue";
import { useRoute } from "vue-router";
import { ChannelVoice } from "@/app/shared/utils/enums";

import { groupBy } from "@/app/ticketsManager/utils/groupBy";
import { sortIconChannels } from "@/app/common/utils/sortIconChannels";

import ChannelDropdownButton from "@/app/workspace/components/buttons/ChannelDropdownButton.vue";

export default {
  components: {
    ChannelDropdownButton,
  },
  props: {
    items: {
      required: true,
      type: Array,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const route = useRoute();
    const ticketInteractionsChannels = inject("ticketInteractionsChannels");
    // Cada llamada es una CallInteraction; se muestra una sola opción por canal + número
    // (el historial de llamadas ya se consulta por identifier + channel_type).
    // Se conserva la interacción seleccionada en la ruta o, si no, la más reciente.
    const visibleInteractionsChannels = computed(() => {
      const selectedId = Number(route.query.interaction);
      const voiceByKey = new Map();
      const others = [];
      for (const interaction of ticketInteractionsChannels.value || []) {
        if (!ChannelVoice.includes(interaction?.channel?.id)) {
          others.push(interaction);
          continue;
        }
        const key = `${interaction.channel.id}-${interaction.identifier}`;
        const current = voiceByKey.get(key);
        if (!current || current.id !== selectedId) voiceByKey.set(key, interaction);
      }
      return [...others, ...voiceByKey.values()];
    });
    const groupedInteractionsChannels = computed(() =>
      groupBy(visibleInteractionsChannels.value, (interaction) => interaction?.channel?.icon)
    );
    const sortedInteractionsChannels = computed(() =>
      sortIconChannels(groupedInteractionsChannels)
    );
    return { ticketInteractionsChannels, groupedInteractionsChannels, sortedInteractionsChannels };
  },
  computed: {
    phoneStatus() {
      return this.$jssip.phone.status;
    },
    globalState() {
      return this.$store.getters["getStateUser"];
    },
    dialingType() {
      return this.$store.getters["getDialingType"];
    },
    dataUserState() {
      return this.$store.getters["getDataUserState"];
    },
  },
};
</script>

<style lang="sass" scoped>
.list
  display: flex
  position: relative
  align-items: center
  overflow-y: clip
  gap: 4px

  // &__item
  //   margin: 0 4px
  //   display: flex
  //   align-items: center
  //   position: relative
  //   cursor: pointer

  //   &--active::before
  //     content: ''
  //     height: 2px
  //     width: 100%
  //     position: absolute
  //     border-radius: 8px
  //     background-color: $blue-6
  //     bottom: -4px
  //     left: 0
  //     right: 0

/* Works on Chrome, Edge, and Safari */
.list::-webkit-scrollbar
  position: absolute
  height: 4px

.list::-webkit-scrollbar-track
  background: transparent

.list::-webkit-scrollbar-thumb
  background-color: #c1c1c1
  border-radius: 2px

/* Works on Firefox */
.list
  scrollbar-width: thin
  scrollbar-color: #c1c1c1 transparent

.skeleton
  height: 32px
  width: 47px
  border-radius: 6px
</style>
